// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../containers/login/view-model/AuthVm.mjs";
import * as NextImage$PorterinFeature from "../../../ui/components/NextImage.mjs";
import * as ButtonIconCmpModuleScss from "../styles/ButtonIconCmp.module.scss";

var styles = ButtonIconCmpModuleScss;

function ButtonIconCmp(Props) {
  var on_click = Props.on_click;
  var label = Props.label;
  return React.createElement("button", {
              className: styles["button-action"],
              onClick: (function (param) {
                  Curry._1(on_click, undefined);
                })
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: AuthVm$PorterinFeature.locate_location_icon.src,
                  height: AuthVm$PorterinFeature.locate_location_icon.height,
                  width: AuthVm$PorterinFeature.locate_location_icon.width,
                  quality: 80.0,
                  alt: AuthVm$PorterinFeature.locate_location_icon.alt
                }), label);
}

var make = ButtonIconCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
